// frontend/src/api/paymentApi.js
import { apiClient } from './index';

const paymentApi = {
  /**
   * Initiates a payment for a service invoice.
   * @param {string} invoiceId
   * @param {boolean} saveCard - User consent to save card
   */
  initiateServicePayment: async (invoiceId, saveCard = false) => {
    return await apiClient.post('/payments/initiate', { 
        invoice_id: invoiceId,
        save_card: saveCard 
    });
  },

  /**
   * Initiates a payment for a product order.
   * @param {string} orderId
   * @param {boolean} saveCard - User consent to save card
   */
  initiateOrderPayment: async (orderId, saveCard = false) => {
    return await apiClient.post('/payments/initiate-order', { 
        order_id: orderId,
        save_card: saveCard 
    });
  },

  /**
   * Force verify a transaction using the ID from the URL.
   */
  verifyTransaction: async (transactionId) => {
    return await apiClient.get(`/payments/verify?transaction_id=${transactionId}`);
  },

  /**
   * Get user's saved cards.
   */
  getSavedCards: async () => {
      return await apiClient.get('/payments/cards');
  },

  /**
   * Charge a saved card token (One-Click).
   */
  chargeSavedCard: async (invoiceId, token) => {
      return await apiClient.post('/payments/charge-token', { 
          invoice_id: invoiceId, 
          token: token 
      });
  }
};

export { paymentApi };